import jwt from 'jsonwebtoken';
import apis from '@src/apis';

const validateKcToken = async (accessToken, refreshToken, idToken) => {
  if (!accessToken || !refreshToken || !idToken) {
    return false;
  }
  try {
    const publicKey = await apis.keycloak.getKeycloakPublicKey();
    const isValidToken = jwt.verify(accessToken, publicKey);
    return isValidToken;
  } catch (err) {
    return false;
  }
};

export { validateKcToken };
